<template>
    <div>
        <navbar/>
        <div style="min-height: 50vh">
            <b-container class="mt-3">
                <div class="d-flex align-content-center justify-content-center pt-5">
                    You have been successfully unsubscribed.
                </div>
            </b-container>
        </div>
        <Footer/>
    </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";

export default
{
    name: "EmailUnsubscribeLanding",
    components: {Footer, Navbar},
    data: () => ({
        success: true,
    }),
    created() {

    }
}
</script>

<style scoped lang="scss">

</style>